import { useLocation } from 'react-router-dom';
import ForbiddenPlateMarkup from './ForbiddenPlateMarkup';
import Container from '../Container/Container';
import { checkSomePermissions } from '../../utils';

export default function ForbiddenPlate({ perms }) {
  const { pathname } = useLocation();

  const isPricesPage = pathname.includes('pricelist');

  const textVariant = isPricesPage ? 'pricelist' : 'default';

  const isOffset = ['catalogs'].some(el => pathname.includes(el));
  const isCatalogPerms = checkSomePermissions(
    [
      'mainapp.view_division',
      'mainapp.view_lpu',
      'mainapp.view_normativeactrow',
      'mainapp.view_normativeactanalysis',
    ],
    perms,
  );

  return isOffset && isCatalogPerms ? (
    <ForbiddenPlateMarkup variant={textVariant} />
  ) : (
    <Container>
      <ForbiddenPlateMarkup variant={textVariant} />
    </Container>
  );
}
